import React from 'react';
import SftpSection from './sftpSection';
import AutoNumberSettingSection from './AutoNumberSettingSection';
import { useSelector } from 'react-redux';
import ConsolidationPeriodSection from './ConsolidationPeriodSection';
import OrgNotificationSection from './OrgNotificationSection';

const OrgSettingsSection = () => {
  const subscription = useSelector((state) => state.org.org.subscription);
  const isSftpFeatureEnabled = subscription?.features?.enable_sftp;
  const isConsolidationFeatureEnabled = subscription?.features?.enable_consolidation;

  return (
    <>
      {isSftpFeatureEnabled && <SftpSection />}
      <AutoNumberSettingSection />
      {isConsolidationFeatureEnabled && <ConsolidationPeriodSection />}
      <OrgNotificationSection />
    </>
  );
};

export default OrgSettingsSection;
